module.exports = __webpack_public_path__ + "media/audio6.8a585edf.mp3";